// Chakra Icons
import { BellIcon } from "@chakra-ui/icons";
// Chakra Imports
import {
  Box, Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList, Stack, Text, useColorMode,
  useColorModeValue
} from "@chakra-ui/react";
// Assets
import avatar1 from "assets/img/avatars/avatar1.png";
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar3 from "assets/img/avatars/avatar3.png";
// Custom Icons
import { ArgonLogoDark, ArgonLogoLight, ChakraLogoDark, ChakraLogoLight, ProfileIcon, SettingsIcon } from "components/Icons/Icons";
// Custom Components
import { ItemContent } from "components/Menu/ItemContent";

import { SidebarResponsive } from "components/Sidebar/Sidebar";
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import routes from "routes.js";
import { getAdminName, getUserData } from "../../utils/auth";
import { authService } from "../../api";
import { Portal } from "@chakra-ui/react";

export default function HeaderLinks(props) {
  const {
    variant,
    children,
    fixed,
    scrolled,
    secondary,
    onOpen,
    ...rest
  } = props;

  const { colorMode } = useColorMode();
  
  // User data state
  const [userData, setUserData] = useState(null);
  
  useEffect(() => {
    const user = getUserData();
    setUserData(user);
  }, []);
  
  // Handle logout
  const handleLogout = async () => {
    try {
      await authService.logout();
    } catch (error) {
      console.warn('Logout failed:', error);
    } finally {
      // Always redirect to signin page
      window.location.href = '#/auth/signin';
    }
  };

  // Chakra Color Mode
  let navbarIcon =
    fixed && scrolled
      ? useColorModeValue("gray.700", "gray.200")
      : useColorModeValue("white", "gray.200");
  let menuBg = useColorModeValue("white", "navy.800");
  if (secondary) {
    navbarIcon = "white";
  }
  return (
    <Flex
      ps={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems='center'
      flexDirection='row'
      direction="rtl"
      className="navbar-container">
      <SidebarResponsive
        hamburgerColor={"white"}
        logo={
          <Stack direction='row' spacing='12px' align='center' justify='center'>
            {colorMode === "dark" ? (
              <ArgonLogoLight w='74px' h='27px' />
            ) : (
              <ArgonLogoDark w='74px' h='27px' />
            )}
            <Box
              w='1px'
              h='20px'
              bg={colorMode === "dark" ? "white" : "gray.700"}
            />
            {colorMode === "dark" ? (
              <ChakraLogoLight w='82px' h='21px' />
            ) : (
              <ArgonLogoDark w='82px' h='21px' />
            )}
          </Stack>
        }
        colorMode={colorMode}
        secondary={props.secondary}
        routes={routes}
        className="navbar-element"
        {...rest}
      />
      
      <Menu zIndex={10000} placement="bottom-end">
        <MenuButton className="navbar-element navbar-icon">
          <BellIcon color={navbarIcon} w='18px' h='18px' />
        </MenuButton>
        <Portal>
          <MenuList 
            p='16px 8px' 
            bg={menuBg} 
            zIndex={10000}
            boxShadow="0 10px 25px rgba(0, 0, 0, 0.15)"
            border="1px solid"
            borderColor="gray.200"
            mt="8px"
            position="relative"
          >
            <Flex flexDirection='column'>
              <MenuItem borderRadius='8px' mb='10px'>
                <ItemContent
                  time='منذ 13 دقيقة'
                  info='من أليسيا'
                  boldInfo='رسالة جديدة'
                  aName='أليسيا'
                  aSrc={avatar1}
                />
              </MenuItem>
              <MenuItem borderRadius='8px' mb='10px'>
                <ItemContent
                  time='منذ يومين'
                  info='بواسطة جوش هنري'
                  boldInfo='ألبوم جديد'
                  aName='جوش هنري'
                  aSrc={avatar2}
                />
              </MenuItem>
              <MenuItem borderRadius='8px'>
                <ItemContent
                  time='منذ 3 أيام'
                  info='تم إكمال الدفع بنجاح!'
                  boldInfo=''
                  aName='كارا'
                  aSrc={avatar3}
                />
              </MenuItem>
            </Flex>
          </MenuList>
        </Portal>
      </Menu>
      <Menu zIndex={10000} placement="bottom-end">
        <MenuButton className="navbar-element navbar-icon">
          <Flex
            alignItems="center"
            cursor="pointer"
            me={{ sm: "2px", md: "16px" }}
            ms={{ sm: "2px", md: "16px" }}
          >
            {(() => {
              const displayName = userData?.name || (
                userData?.first_name || userData?.last_name
                  ? `${userData?.first_name || ''} ${userData?.last_name || ''}`.trim()
                  : 'Admin'
              );
              const avatarSrc = userData?.profile_photo || userData?.avatar || userData?.logo || avatar1;
              return (
                <>
            <Box
              w="40px"
              h="40px"
              borderRadius="50%"
              overflow="hidden"
              border="2px solid"
              borderColor={navbarIcon}
              me="8px"
            >
              <img
                src={avatarSrc}
                alt="صورة الملف الشخصي"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                onError={(e) => {
                  e.target.src = avatar1;
                }}
              />
            </Box>
            <Text
              display={{ sm: "none", md: "flex" }}
              color={navbarIcon}
              fontSize="14px"
              fontWeight="600"
              me="8px"
            >
              {displayName}
            </Text>
                </>
              );
            })()}
          </Flex>
        </MenuButton>
        <Portal>
          <MenuList 
            p='16px 8px' 
            bg={menuBg}
            zIndex={10000}
            boxShadow="0 10px 25px rgba(0, 0, 0, 0.15)"
            border="1px solid"
            borderColor="gray.200"
            minW="200px"
            mt="8px"
            position="relative"
          >
            <Flex flexDirection='column'>
              <MenuItem 
                borderRadius='8px' 
                mb='10px'
                onClick={handleLogout}
                cursor="pointer"
                _hover={{ bg: 'gray.100' }}
                py="12px"
                px="16px"
              >
                <Flex alignItems="center">
                  <ProfileIcon color="gray.600" w='18px' h='18px' me="8px" />
                  <Text fontSize="14px" fontWeight="500">تسجيل الخروج</Text>
                </Flex>
              </MenuItem>
            </Flex>
          </MenuList>
        </Portal>
      </Menu>

    </Flex>
  );
}